/* The one sentence `SurveyActions` owns.
 *
 * It is drawn in three heads — the matrix's, the report's and the comparison's — and it was written
 * out byte for byte in `SurveysTab.module.css` and the pane's own sheet. One home, because a
 * failure notice that reads differently in two of the three places it can appear is worse than no
 * notice at all. */

.alert {
  flex: none;
  max-width: var(--w-survey-alert);
  margin: var(--space-0);
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  line-height: var(--lh-normal);
  color: var(--danger-text-strong);
}

/* „Przejrzane": the check and the word in a 34px ember pill; the fill and its states are
 * `shared/ui/emberButton.module.css`'s, this is geometry only. */
.markPill {
  gap: var(--space-6px);
  height: var(--h-control);
  padding: var(--space-0) var(--space-14px) var(--space-0) var(--space-3);
  font-size: var(--type-control);
  font-weight: var(--fw-semibold);
  border-radius: var(--r-pill);
}
